// Vendor imports
const { connect } = require('react-redux')
const { createSelector } = require('reselect')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const authModalActions = require('client-v2/common/containers/auth-modal/actions')
const { defaultFeedActions: feedActions } = require('client-v2/common/containers/feed/actions')
const { defaultFeedSelectors: feedSelectors } = require('client-v2/common/containers/feed/selectors')
const articleActions = require('client-v2/common/models/article/actions')
const { authRequired } = require('client-v2/common/state/user/actions')
const tag = require('client-v2/common/utils/hyperscript')

function mapStateToProps() {
  const titleElementSelector = createSelector(
    feedSelectors.getTitle,
    title => Boolean(title) && tag('div', title)
  )
  return (state, ownProps) => {
    return {
      headerElement: ownProps.headerElement || titleElementSelector(state),
      isMoreAvailable: feedSelectors.getIsNextPageAvailable(state),
      isMoreLoading: feedSelectors.getIsNextPageLoading(state),
      items: feedSelectors.getDenormalizedItems(state)
    }
  }
}

const mapDispatchToProps = {
  onArticleBookmark: authRequired(
    articleActions.handleArticleAddAction,
    authModalActions.showSignup
  ),
  onArticleContentNavigate: articleActions.navigateToArticleContent,
  onArticleDomainNavigate: articleActions.navigateToArticleDomainSearch,
  onArticleEmbedDisclose: articleActions.trackContentView,
  onArticleMoreActions: authRequired(
    articleActions.showArticleActionsModal,
    authModalActions.showSignup
  ),
  onArticleRate: articleActions.rateArticle,
  onArticleSeen: articleActions.trackGridView,
  onArticleShare: articleActions.showArticleShareModal,
  onLoadMore: feedActions.loadMore
}

module.exports = (
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(
    withImmutableToJS(
      require('./component-dumb')
    )
  )
)
